export const formattedGramsToKilograms = (grams, options = {}) => {
  const { toFixed = 100 } = options;
  if (typeof grams !== 'number') throw new Error('grams ожидает тип number');
  if (grams === 0) return grams;
  const value = grams / 1000;
  return Number(value.toFixed(toFixed));
};
